/* eslint-disable */
import React, { Component } from "react";
import {
  FormControl,
  FormLabel,
  Grid,
  GridItem,
  Input,
} from "@chakra-ui/react";
import { connectModal } from "redux-modal";
import { withTranslation } from "react-i18next";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import CancelIcon from "@material-ui/icons/Cancel";
import IconButton from "@material-ui/core/IconButton";
import { connect } from "react-redux";
import { createFund } from "../../utils/store/actions/funds.actions";
import "react-toastify/dist/ReactToastify.css";
import { B4FText } from "../component-questionnaire/B4FFields/B4FText";

class ModalCreateFund extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      fund: {
        person: {
          name: "",
        },
      },
      toast: false,
    };
  }
  handleChange = (e: any) => {
    this.setState({
      fund: {
        person: {
          name: e.value,
        },
      },
    });
  };

  handleCreate = (e: any) => {
    this.setState({ preview: !this.state.preview });
  };

  create = () => {
    this.props.createFund(this.state.fund);
  };

  render() {
    const { show, handleHide, t } = this.props;
    const closeBtn = (
      <IconButton className="close" onClick={handleHide}>
        <CancelIcon />
      </IconButton>
    );
    return (
      <div>
        <Modal
          isOpen={show}
          toggle={handleHide}
          backdrop={true}
          style={{
            backgroundColor: "#f5f6ff",
          }}
        >
          <ModalHeader
            toggle={handleHide}
            close={closeBtn}
            style={{
              backgroundColor: "#f5f6ff",
              fontWeight: "bolder",
            }}
          >
            {t("CREATE_PRODUCT")}
          </ModalHeader>
          <ModalBody
            style={{
              backgroundColor: "#f5f6ff",
            }}
          >
            <Grid
              templateRows="repeat(1, 1fr)"
              templateColumns="repeat(2, 1fr)"
              style={{
                backgroundColor: "white",
                padding: "5%",
                borderRadius: "5px",
              }}
            >
              <GridItem rowSpan={1} colSpan={2}>
                <B4FText
                  label="NAME"
                  id="person.name"
                  key="person.name"
                  value={this.state?.fund?.person?.name}
                  onBlur={console.log}
                  placeholder=""
                  onChange={(e: any) => this.handleChange(e)}
                  visible={true}
                  isRequired={true}
                />
              </GridItem>
            </Grid>
          </ModalBody>
          <ModalFooter
            style={{
              backgroundColor: "#f5f6ff",
              borderRadius: "10px",
            }}
          >
            <>
              <Button
                style={{
                  color: "rgb(99, 110, 149)",
                  border: "2px solid",
                  background: "none",
                }}
                onClick={handleHide}
              >
                {t("CANCEL")}
              </Button>
              <Button
                style={{ backgroundColor: "#ae0064", color: "white" }}
                onClick={this.create}
              >
                {t("CREATE")}
              </Button>
            </>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});
const mapDispatchToProps = {
  createFund,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(connectModal({ name: "create_fund" })(ModalCreateFund)));
